import { useEffect, useState, createContext, useContext } from "react";
import _ from 'lodash'
import { RefetchContext } from "./refetchProvider";
import hash from 'hash-it';

export const ImportWizardContext = createContext({});

const steps = ['Upload Data', 'Map Columns', 'Validate', 'Import'];

// const normalizePath = (o: any, p: string) => _.chain(o).get(p).replace(/\s/g,'').replace(/\./g,'_dot_').toLower().value()
// const normalizeString = (o: string) => _.chain(o).replace(/\s/g,'').replace(/\./g,'_dot_').toLower().value()

const normalizePath = (o: any, p: string) => _.toString(hash(_.get(o,p)))
const normalizeString = (o: string) => _.toString(hash(o))

const ImportWizardProvider = ({ children }: any) => {
  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState<{
    [k: number]: boolean;
  }>({});

  const [numFiles, setNumFiles] = useState('not-selected')
  const [fileObjects, setFileObjects] = useState([]);

  const [sheetSelection, setSheetSelection] = useState<any>({});

  const [viewSelection, setViewSelection] = useState<any>({})

  const [inputConfig, setInputConfig] = useState({})
  const [config, setConfig] = useState({})

  const [errors, setErrors] = useState([])
  const [stickyErrors, setStickyErrors] = useState({})
  const [errorTick, setErrorTick] = useState(0)
  const [stepCompletedTick, setStepCompletedTick] = useState(0)

  const context = useContext(RefetchContext);

  const [existingViews, setExistingViews] = useState([])
  const [selectedViews, setSelectedViews] = useState<any>([])
  const [candidateViews, setCandidateViews] = useState<any>([])

  const [ summary, setSummary ] = useState<any[]>([])

  const allViews = context?.allViews;

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  useEffect(()=>{
    const updateExistingViews = () => {
      setExistingViews(
        //@ts-ignore
        _.chain(allViews)
        .filter(v => !!!v?.rootViewId)
        .map(v=>{
        const { name, columns } = v

        const fields = _.reduce(columns, (r,c)=>{
          if (_.chain(c).get('headerName').isNil().thru(o=>!o).value() && _.chain(c).get('field').startsWith('merc_').thru(o=>!o).value()) {
            //@ts-ignore
            r.push(_.chain(c).get('headerName').trim().value())
          }
          return r
        },[])

        return ({
          //@ts-ignore
          _id: _.chain(v).get('_id').toString().value(),
          exists: true,
          name,
          fields
        })
      }).value())
    }
    if (!_.isNil(allViews) && !_.isEmpty(allViews)) {
      updateExistingViews()
    }
  },[allViews])

  const handleNext = () => {
    // setErrorTick(errorTick+1)

    const newActiveStep =
        isLastStep() && !allStepsCompleted()
          ? // It's the last step, but not all steps have been completed,
            // find the first step that has been completed
            steps.findIndex((step, i) => !(i in completed))
          : activeStep + 1;
      setActiveStep(newActiveStep);
  };

  const handleBack = () => {

    let newCompleted = _.clone(completed);

    //@ts-ignore
    newCompleted[activeStep] = false

    setCompleted(newCompleted);

    setActiveStep((prevActiveStep: any) => prevActiveStep - 1);
  };

  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();

  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };


  const handleNumFilesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNumFiles((event.target as HTMLInputElement).value);
  };

  return (
    <ImportWizardContext.Provider value={{
      steps,
      normalizePath, normalizeString,
      existingViews,
      candidateViews, setCandidateViews,
      selectedViews, setSelectedViews,
      open, setOpen,
      activeStep, setActiveStep,
      completed, setCompleted,
      totalSteps,
      completedSteps,
      isLastStep,
      allStepsCompleted,
      handleNext,
      handleBack,
      handleStep,
      handleComplete,
      handleReset,
      numFiles, setNumFiles,
      handleNumFilesChange,
      fileObjects, setFileObjects,
      sheetSelection, setSheetSelection,
      viewSelection, setViewSelection,
      inputConfig, setInputConfig,
      config, setConfig,
      errors, setErrors,
      stickyErrors, setStickyErrors,
      errorTick, setErrorTick,
      summary, setSummary
    }}>
      {children}
    </ImportWizardContext.Provider>
  );
};

export default ImportWizardProvider;
